import React from 'react'

interface CheckboxProps {
  id: string
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
}

const Checkbox = ({ id, label, checked, onChange }: CheckboxProps): JSX.Element => (
  <label htmlFor={id} className="flex items-center cursor-pointer select-none">
    <input
      type="checkbox"
      id={id}
      checked={checked}
      onChange={(evt: React.ChangeEvent<HTMLInputElement>) => { onChange(evt.target.checked) }}
      className="w-4 h-4 text-teal-500 bg-gray-50 border-gray-300 rounded focus:ring-teal-500 focus:ring-2 cursor-pointer"
    />
    <span className="ml-2 text-sm text-gray-600">{label}</span>
  </label>
)

export default Checkbox
